import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../../common/chart/legend'
import { Element } from '../../../../../../common/html/element'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../../helpers/common'
import { formatByTheme } from '../../../../../../helpers/theme'
import {
  convertData,
  formatVal,
  isInValidValue,
} from '../../../../../../helpers/value'
import { selectUserType } from '../../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../../utils/authorization'
import { getValueAndTitleCheckbox } from '../../../helper'
import classes from '../../../index.module.scss'
import { changeChecked, selectChecked } from '../../../store/slice'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'
import { TERM_DATA } from './constant'

const Term = ({ id, check, isDynamicReport }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()

  const {
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    formatedUnit,
    currency,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))
  const locale = useSelector((state) => state.i18n.locale)

  const checked = checkedStore || check

  const checkboxs = TERM_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const handleSetChecked = (checked) => {
    if (checkboxs.some((checkbox) => checked.includes(checkbox.value))) {
      dispatch(changeChecked({ id, checked }))
    }
  }

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
  ).reverse()

  const bars = checkboxs.filter((item) => checked.includes(item.value))
  const groupStackBarKeys = bars.map((bar) => bar.value)

  return (
    <div className="h100 flexColumn" style={{ minHeight: 200 }}>
      <div className="fw600 pb1">
        <Translate value="financialAnalysis.LOAN_PORTFOLIO_BY_TERM" />
      </div>
      <div className="h100 dFlex">
        <div className="w70 h100">
          <ChartContainer
            chartId={chartId.current}
            data={dataConvert}
            width="100%"
            height="100%"
            layout="vertical"
            margin={{
              top: 10,
              bottom: 0,
              left: 0,
              right: 37,
            }}
            cartesianGrid={{ vertical: true, horizontal: false }}
            yAxis={[
              {
                dataKey: 'year',
                yAxisId: 'left',
                type: 'category',
              },
            ]}
            xAxis={[
              {
                dataKeys: bars.map((item) => item.value),
                isStackedBar: true,
                type: 'number',
                axisLine: false,
                tick: { fill: formatByTheme('#9C9C9C') },
                tickCount: 3,
                tickFormatter: (val) =>
                  formatVal(val, locale, undefined, currency === 'VND' ? 0 : 2),
              },
            ]}
            tooltip={{
              schema: {
                content: bars.map((item) => ({
                  dataKey: item.value,
                  label: item.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
              },
            }}
          >
            {bars.map((bar, barIndex) => (
              <Bar
                key={bar.value}
                yAxisId="left"
                dataKey={bar.value}
                fill={bar.color}
                stackId="stack"
                maxBarSize={25}
                showLabelEmpty={({ index }) =>
                  barIndex === 0 &&
                  groupStackBarKeys.every((dataKey) =>
                    isInValidValue(dataConvert[index][dataKey]),
                  )
                }
              />
            ))}
          </ChartContainer>
        </div>
        <div className="h100 w30 flexColumn">
          <div className="h100 dFlex alignItemsCenter">
            <Legend
              chartId={chartId.current}
              items={checkboxs.map((item) => ({
                title: item.title,
                value: item.value,
                dataKey: item.value,
                color: item.color,
                isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
                listCheckBox: checked,
                setListCheckBox: handleSetChecked,
                isI18n: false,
                isDynamicReport: isDynamicReport,
              }))}
              className="flexColumn"
            />
          </div>
          <Element
            style={{ color: '#9C9C9C' }}
            className={`textEnd ${classes.mb3}`}
          >
            {formatedUnit}
          </Element>
        </div>
      </div>
    </div>
  )
}

export default Term
